export const REGEX_NUMBER = /^\d+$/;
